import React from 'react';

interface ErrorPageProps {
  error?: Error;
  resetError?: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ error, resetError }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-xl w-full bg-white rounded-lg shadow-lg p-8 m-4">
        <h1 className="text-2xl font-bold text-red-600 mb-4">Algo salió mal</h1>
        <p className="text-gray-600 mb-4">
          Lo sentimos, ha ocurrido un error. Por favor, intente recargar la página.
        </p>
        {error && (
          <pre className="bg-gray-100 p-4 rounded mb-4 overflow-auto text-sm">{error.message}</pre>
        )}
        <button
          onClick={() => (resetError ? resetError() : window.location.reload())}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          Recargar página
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
